import { object } from "yup";

import { IEReservationQueueFormField } from "modules/queues/types/IEReservationQueueFormField";
import { fieldValidationSchemaGenerator } from "modules/queues/application/fieldValidationSchemaGenerator";

import { useRecaptchaValidationSchema } from "utils/yup/useRecaptchaValidationSchema";
import { validationMessages } from "utils/yup/validationMessages";
import { checkboxRequiredValidationSchema } from "utils/yup/checkboxRequiredValidationSchema";
import { IDynamicFieldSchema } from "utils/yup/IDynamicFieldSchema";

export const useEditAppointmentFormValidationSchema = (
  formFields: IEReservationQueueFormField[]
) => {
  const recaptchaValidationSchema = useRecaptchaValidationSchema();

  let dynamicFieldsSchema: IDynamicFieldSchema = {
    "recaptcha-response": recaptchaValidationSchema,
    termAccept: checkboxRequiredValidationSchema.required(
      validationMessages.requiredField
    ),
  };

  formFields.forEach((formField) => {
    dynamicFieldsSchema[formField.name] = fieldValidationSchemaGenerator(
      formField
    );
  });

  return object().shape(dynamicFieldsSchema);
};
